module.exports = __webpack_public_path__ + "img/shops_8.590f7b38.jpg";